module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAyElEQVQ4ja3UMU5CQRSF4Q9z92CroXQTuAMat2DMqyip7eh0J1JTwAZo6YgUVBYmkGhlgoVgyBMe3DinmZzMuf9k5t5MazT92Cioi5IwCNyWBk5KA58S+Ue8NwVayaZcY7HnbzDDLyMwTAA/a/4Ol6h20EA3ATykh+1aYRO4ShQv8dUEDbwmgPU3/AMtPdir2J56rpYNewP0w/ErZDRAn58uvyQK7/F2DMb/B7uN+X4g8JwArmt+Xg8EegngSQU6pYHjksDiP/Y331EpGFdRBEcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/waterSystem/img/right_dark.png
// module id = ngVT
// module chunks = 163